import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-new-admin-processing-transport',
  templateUrl: './new-admin-processing-transport.component.html',
  styleUrls: ['./new-admin-processing-transport.component.scss'],
})
export class NewAdminProcessingTransportComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  transportData: any;
  tranportForm!: FormGroup;
  transportAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  organizationlist: any;
  transportList: any;
  regionList: any;
  selectOrganization: any;
  regionData: any;
  selectRegion: any;
  setIndicatorData: any;
  indicatorList: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  @Output() saveNewTransportEvent = new EventEmitter<any>();

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private administratorService: AdministratorService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.transportData = this.modal?.modalService?.config?.initialState?.['newTransportData'];
    this.isDisabledDropDown = this.modalLabel == 'Review conversion detail' ? true : false;

    const placeHolderOrganization = {
      name: 'All organization',
    };

    const newOrganizationlist = [placeHolderOrganization].concat(
      this.transportData.organizationList
    );

    this.indicatorList = this.transportData.indicatiorList;
    this.organizationlist = newOrganizationlist;
    this.transportList = this.transportData.transportModeItems;
    this.regionList = this.transportData.regionItems;
    this.organizatioListFunction();
    this.getRegionData();
  }

  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      form[this.indicatorList[i].name] = new FormControl(
        this.transportData.indicatiorList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.tranportForm = new FormGroup(form);
    this.transportAddEditForm = this.formBuilder.group({
      transport: [this.transportData.transportModeId || null, Validators.required],
      region: [null, Validators.required],
      organizationName: [this.transportData.organizationId || this.organizationlist[0] || null],
    });
    this.setFormData();
  }

  onClose() {
    this.modal.close();
  }

  onChange(value: any) {
    this.transportAddEditForm.controls['region'].setValue(null);
    if (!!value?.id) {
      this.administratorService.GetRegionsForTransport(value.id).subscribe((data: any) => {
        this.regionData = data.data;
      });
    } else {
      this.regionData = [];
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.transportData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  async getRegionData() {
    await this.regionList.map((item: any) => {
      if (item.id == this.transportData.regionId) {
        return (this.selectRegion = item);
      }
    });
  }

  setFormData() {
    this.transportAddEditForm.patchValue({
      region: this.selectRegion,
      organizationName: this.selectOrganization,
    });
  }

  onSave() {
    this.submitted = true;
    if (
      this.transportAddEditForm.controls['region'].value?.name == '--Select Region-- ' ||
      (this.activatedRoute == 'Transport' &&
        !this.transportAddEditForm.controls['region'].value?.name)
    ) {
      return;
    }
    if (this.transportAddEditForm.status == 'VALID' && this.tranportForm.status == 'VALID') {
      const entires = Object.entries(this.tranportForm.value);
      const resultArray: any = [];
      let i = {};
      const entiresArray = this.transportData.indicatiorList.map((obj: any, index: any) => ({
        ...obj,
        ...entires[index],
      }));
      entiresArray.forEach((event: any, index: any) => {
        i = {
          indicatorId: event.indicatorId,
          name: event.name,
          unit: event.unit,
          defaultValue: event[1],
          equivalencyUnits: event.equivalencyUnits,
          multiplier: event.multiplier,
        };
        resultArray.push(i);
      });
      const trasnportPayload = {
        transportModeId: this.transportAddEditForm.controls['transport'].value,
        regionId:
          this.transportAddEditForm.controls['region'].value?.id || this.transportData.regionId,
        organizationId:
          this.transportAddEditForm.controls['organizationName'].value?.name ==
            'All organization' ||
          this.transportAddEditForm.controls['organizationName'].value?.name == undefined
            ? null
            : this.transportAddEditForm.controls['organizationName'].value?.id,
        indicatiorList: resultArray,
      };
      this.saveNewTransportEvent.emit(trasnportPayload);
      this.onClose();
    }
  }
}
